module.exports = __webpack_public_path__ + "img/Icon_CartaAfirmativa_PEI_Hover.59eb36d5.svg";